import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_code = (login, password) => {
  // 发送验证码时不需要 token，使用单独的配置避免拦截器添加 token
  return api.post(
    `${ApiEndpointConstants.GETCODE}`,
    { login, password },
    {
      // 跳过 token 拦截器，因为这是登录前的请求
      skipAuth: true,
    }
  );
};
